<template>
  <div class="l-edit-dialog-box">
      <!-- <div class="l-table-place">
          <div class="flex flex-warp">
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">编码</p>
              <el-input
                placeholder="请输入编码"
                v-model="search_data.material_code"
                class="input-with-select"
                style="width: 80%;"
              >
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
              </el-input>
            </div>
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">名称</p>
              <el-input
                placeholder="请输入名称"
                v-model="search_data.name"
                class="input-with-select"
                style="width: 80%;"
              >
                <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
              </el-input>
            </div>
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">分类名</p>
              <el-cascader v-model="search_data.type_id" :options="type_node" :props="{ checkStrictly: true }" clearable style="width:600px;"/>
              </el-cascader>
              <el-button slot="append" icon="el-icon-search" @click="onSearch"></el-button>
            </div>
            
            <div class="flexs items-center ivu-mt ivu-mr">
              <p class="mr1">状态</p>
              <el-select v-model="search_data.material_state_id" placeholder="请选择状态" clearable  style="width:70%">
                <el-option v-for="item in material_state_list" style="width:80%" :key="item.id" :label="item.name" :value="item.id"> </el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click="onSearch" style="width:20%"></el-button>
            </div>
      
          </div>     
      </div> -->
    
    <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="培训分项" name="first">
            <div>
                <l-auth-button type="primary" auth="cabinet_detail_add_btn" @click="add_visible = true"> 新增培训分项</l-auth-button>
              <!-- <el-button @click="cancel">返 回</el-button> -->
              <!-- <l-auth-button type="primary" auth="cabinet_detail_add_btn" @click="handleSubmit" :loading="submitting">添 加</l-auth-button> -->
            </div>

            <l-table :data="data" v-loading="loading" row-key="id">
                <el-table-column prop="train_name" label="培训项目" min-width="200"> </el-table-column>
              <el-table-column prop="material_name" label="培训分项名称" min-width="200"> </el-table-column>
              <el-table-column prop="specification_name" label="培训方式" min-width="80"> </el-table-column>

              <el-table-column prop="producted_at" label="开始培训日期" min-width="80"> 
                <template slot-scope="{ row }">
                    <el-date-picker v-model="row.producted_at" type="date" autocomplete="off" clearable
                        placement="bottom-start"
                        value-format="yyyy-MM-dd" placeholder="请选择开始培训时间" 
                        v-show="row.show" />
                    <span v-show="!row.show">{{row.producted_at.substring(0,10)}}</span>
                </template>
              </el-table-column>
                
              <el-table-column prop="material_quantity" label="培训时长" min-width="80"> 
                <template slot-scope="{ row }">
                    <el-input-number v-model="row.material_quantity" size="small" :min="0" autocomplete="off" placeholder="请输入时长" 
                        v-show="row.show" />
                    <span v-show="!row.show">{{parseInt(row.material_quantity)}}</span>
                </template>
              </el-table-column>
              
              <el-table-column prop="material_sku_name" label="时长单位" min-width="80"> </el-table-column>
              <el-table-column prop="material_state_name" label="状态" min-width="80"> </el-table-column>
              
              <!-- <el-table-column prop="created_at" label="创建时间" width="180"> </el-table-column> -->
              <el-table-column fixed="right" label="操作" width="350" align="center">
                <template slot-scope="{ row }">
                    <l-auth-text-button type="primary" auth="cabinet_detail_info_btn" 
                        @click="showInfo(row.id)">
                        <i class="el-icon-warning-outline"></i>
                        拣选试题
                    </l-auth-text-button>
                    <span class="l-action-separator">|</span>
                  <!-- <l-auth-text-button type="primary" auth="cabinet_detail_edit_btn" @click="edit(row,'edit')" v-show="!row.show">
                      <i class="el-icon-edit"></i>编辑</l-auth-text-button>
                  <l-auth-text-button type="primary" auth="cabinet_detail_edit_btn" @click="edit(row,'save')" v-show="row.show">
                      <i class="el-icon-edit"></i>保存</l-auth-text-button>
                  <l-auth-text-button type="primary" auth="cabinet_detail_edit_btn" @click="edit(row,'cancel')" v-show="row.show">
                      <i class="el-icon-edit"></i>取消</l-auth-text-button> -->
                    
                    <l-auth-text-button type="primary" auth="cabinet_detail_edit_btn" @click="showEdit(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
                  <span class="l-action-separator">|</span>
                  <l-auth-text-button type="danger" auth="cabinet_detail_del_btn" @click="del(row.id)">
                      <i class="el-icon-delete"></i>删除</l-auth-text-button>
                </template>
              </el-table-column>

            </l-table>
        </el-tab-pane>
        <el-tab-pane label="培训期限设置" name="second">
            <div>
                <l-auth-button type="primary" auth="train_period_add_btn" @click="add_train_period_visible = true"> 新增培训期限</l-auth-button>
            </div>
            
            <l-table :data="org_user_site" v-loading="loading" row-key="id">
                <el-table-column prop="org_name" label="所属单位" min-width="80"> </el-table-column>
                <el-table-column prop="site_name" label="培训项目" min-width="80"> </el-table-column>
                <el-table-column prop="train_start_date" label="开始培训日期" min-width="80"> 
                    <template slot-scope="{ row }">
                        <el-date-picker v-model="row.train_start_date" type="date" autocomplete="off" clearable
                            placement="bottom-start"
                            value-format="yyyy-MM-dd" placeholder="请选择开始培训时间" 
                            v-show="row.show" />
                        <span v-show="!row.show">{{row.train_start_date.substring(0,10)}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="train_end_date" label="结束培训日期" min-width="80">
                    <template slot-scope="{ row }">
                        <el-date-picker v-model="row.train_end_date" type="date" autocomplete="off" clearable
                            placement="bottom-start"
                            value-format="yyyy-MM-dd" placeholder="请选择结束培训时间" 
                            v-show="row.show" />
                        <span v-show="!row.show">{{row.train_end_date.substring(0,10)}}</span>
                    </template>
                </el-table-column>
                
                <el-table-column fixed="right" label="操作" width="350" align="center">
                    <template slot-scope="{ row }">
                        <l-auth-text-button type="primary" auth="train_period_edit_btn" 
                            @click="showEditPeriod(row.id)"><i class="el-icon-edit"></i>编辑</l-auth-text-button>
                        <span class="l-action-separator">|</span>
                        <l-auth-text-button type="danger" auth="train_period_del_btn" 
                            @click="del(row.id)"><i class="el-icon-delete"></i>删除</l-auth-text-button>
                    </template>
                </el-table-column>
            </l-table>
        </el-tab-pane>
    </el-tabs>
    
    <!--添加模板柜物资-->
    <l-dialog :visible.sync="add_visible" title="添加培训分项" width="1000px">
      <l-material-add @on-success="onAddSuccess" :visible.sync="add_visible" :train_id="this.$props.id"></l-material-add>
    </l-dialog>
    
    <!--添加培训期限-->
    <l-dialog :visible.sync="add_train_period_visible" title="添加培训期限" width="1000px">
      <l-train-period-add @on-success="onAddPeriodSuccess" :visible.sync="add_train_period_visible" :train_id="this.$props.id"></l-train-period-add>
    </l-dialog>
    
    
    <!--编辑培训分项-->
    <l-dialog :visible.sync="edit_visible" title="编辑培训分项" width="1000px">
      <l-material-add @on-success="onEditSuccess" :visible.sync="edit_visible" :id="this.edit_id"></l-material-add>
    </l-dialog>
    
    <!--编辑培训期限-->
    <l-dialog :visible.sync="edit_train_period_visible" title="编辑培训期限" width="1000px">
      <l-train-period-add @on-success="onEditPeriodSuccess" :visible.sync="edit_train_period_visible" :id="this.edit_id"></l-train-period-add>
    </l-dialog>
    
    <!--培训分项详情-试题库-->
    <l-dialog :visible.sync="info_visible" title="培训分项试题设置" width="2000px">
      <l-permission-edit :visible.sync="info_visible" :id="info_id" :material_stock_id="info_id" is-info />
    </l-dialog>
  </div>

    

</template>

<script>
// import {
//   types
// } from './lavel.js';
// console.log(types)
import MaterialAdd from "./MaterialAdd.vue";
import TrainPeriodAdd from "./TrainPeriodAdd.vue";
import MaterialItemBank from "./MaterialItemBank.vue";
export default {
  name: 'l-material-list',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    
    // place_type: {
    //   type: [String, Number],
    //   default: null
    // },
    material_type: {
      type: [String, Number],
      default: null
    },
    visible: {
      type: Boolean,
    },
    useType: {
      type: [Number],
      default: 1
    },
  },

  components: {
      [MaterialAdd.name]: MaterialAdd,
      [TrainPeriodAdd.name]: TrainPeriodAdd,
      [MaterialItemBank.name]: MaterialItemBank,
  },
  computed: {
    hasId() {
        console.log('MaterialList.Id:' + this.$props.id)
      return this.$props.id !== null;
    },
    // place_type_list() {
    //   return this.$store.state.list.place_type_list
    // }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getData();

        }
      }
    },
    // "form_data.is_node"(val){
    //   if(val!=0){
    //     this.form_data.pid=""
    //   }
    // },
    // "form_data.pid"() {
    //   if (!this.getdata_flag) {
    //     this.form_data.type = ""
    //   } else {
    //     this.getdata_flag = false
    //   }
    //   this.changes();
    // }
  },
data() {
    return {
        activeName: 'first',
        data: [],
        org_user_site: [],
        count: 0,
      loading: false,//页面是否加载中
      getdata_flag: false,
      // LAVEL_LIST: types,
      //是否显示
      type_node: [

      ],
      material_sku_list: [],
      material_state_list: [],
      edit_visible: false, //是否显示编辑
      edit_train_period_visible: false,
      edit_id: 0,
      //表单数据
      form_data: {
        // is_node: 0,
        // pid: "",
        material_name: '',
        material_code: '',
        // department_level: '',
        abbreviation: '',
        // place_type: '',
        // is_public: 1,
      },
      nodeList: [],
      material_list: [],
      specification_list: [],
      //分类
      sel_type_id: "",
      type_name: "",
      material_id: 0,
      info_visible: false,
      info_id: 0,
        add_visible: false, //是否显示添加分项
        add_train_period_visible: false, //是否显示添加培训期限
        search_data: {
          keywords: "",
          material_code: "",
          name: "",
          type_id: [],
        },
      //表单验证规则
      rules: {
        type_id: [
          { required: true, message: '器材分类不能为空', trigger: 'change' }
        ],  
        material_name: [
          { required: true, message: '器材名称不能为空', trigger: 'change' }
        ],
        material_quantity: [
          { required: true, message: '投放数量不能为空', trigger: 'change' }
        ],
        producted_at: [
          { required: true, message: '出厂日期不能为空', trigger: 'change' }
        ],
      },
      //提交按钮是否显示加载中
      submitting: false,
    }
  },
  mounted() {

  },


  methods: {
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit('update:visible', false);
    },
    handleClick() {
    },
    func_click(e) {
      if (this.form_data.type == '' && e) {
        this.$alert('请先选择等级', '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    // changes() {
    //   this.$_invoke("industry_getData", {
    //     type: this.form_data.type
    //   }).then((ret) => {  
    //     this.nodeList = ret.data
    //   })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    
    //点击搜索按钮
    onSearch() {
      this.page = 1;
      this.rel_search_data = this.search_data;
      this.getList();
    },
    
    //点击重置搜索框
    onReset() {
      this.$refs.search_form.resetFields();
      this.rel_search_data = {};
    },
    
    //显示试题详情
    showInfo(id) {
        // console.log(id);
      this.info_id = id;
      this.$nextTick(() => {
        this.info_visible = true;
      });
    },
    
    //显示修改分项界面
    showEdit(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_visible = true;
      });
    },
    
    //显示修改期限界面
    showEditPeriod(id) {
      this.edit_id = id;
      this.$nextTick(() => {
        this.edit_train_period_visible = true;
      });
    },
    
    //页码改变
    pageChange(page) {
      this.page = page;
      this.getList();
    },
    
    //每页显示条数改变
    pageSizeChange(page_size) {
      this.page_size = page_size;
      this.getList();
    },
    
    //添加成功回调
    onAddSuccess() {
      this.add_visible = false;
      this.getData();
    },
    //添加期限成功回调
    onAddPeriodSuccess() {
      this.add_train_period_visible = false;
      this.getData();
    },
    
    //编辑成功回调
    onEditSuccess() {
      this.edit_visible = false;
      this.getData();
    },
    
    //编辑成功回调
    onEditPeriodSuccess() {
      this.edit_train_period_visible = false;
      this.getData();
    },

    //获取数据
    getData() {
//       this.$_invoke(`trainTemplate_saveData`, ).then((ret) => {
// console.log(ret);
//         this.tree_node = ret.tree_node;
//       }).finally(() => {
//         this.loading = false;
//       });
      if (this.hasId) {
        this.loading = true;
        this.$_invoke(`trainManage_getMaterialList`, { id: this.$props.id }).then((ret) => {
            this.data = ret.data;
            this.org_user_site = ret.org_user_site_list;
            this.count = ret.count;
          // this.form_data = ret.data;
          this.type_node = ret.type_node;
          this.material_sku_list = ret.material_sku_list;
          this.material_state_list = ret.material_state_list;
          this.getdata_flag = true;
          
          // this.data.forEach(element => {
          //     element["show"] = false;
          // })
          
        }).finally(() => {
          this.loading = false;
        });
      } else {
        // this.form_data.use_type = this.$props.useType
      }

    },

    changeMaterialType(typeid) {
        console.log(typeid);
        let sel_type_id = typeid
        if (typeof sel_type_id != "number") {
          const pid_len = sel_type_id.length;
          sel_type_id = sel_type_id[pid_len - 1];
        }
        
        this.loading = true;
        this.$_invoke(`trainManage_getMaterialListByTypeId`, {sel_type_id }).then((ret) => {
            this.material_list = ret.material_list;
        }).finally(() => {
          this.loading = false;
        });
    },
    
    changeMaterial(materialname) {
        console.log(materialname);
        let sel_material_name = materialname
        
        this.loading = true;
        this.$_invoke(`trainManage_getSpecificationListByMaterialName`, {sel_material_name }).then((ret) => {
            this.specification_list = ret.specification_list;
        }).finally(() => {
          this.loading = false;
        });
    },

    changeSpecification(materialname,specificationid) {
        let sel_material_name = materialname
        let sel_specification_id = specificationid
        this.loading = true;
        this.$_invoke(`trainManage_getMaterialIdByMaterialNSpecification`, {sel_material_name,sel_specification_id })
            .then((ret) => {
                this.material_id = ret.material_id;
            })
            .finally(() => {
                this.loading = false;
            });
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {

        if (valid) {
          // let form_data = Object.assign({}, this.form_data);
          // if (typeof form_data.pid != "number") {
          //   const pid_len = form_data.pid.length;
          //   form_data.pid = form_data.pid[pid_len - 1];
          // }
          this.submitting = true;
          // this.form_data.place_type = 3;
          if (this.hasId) {//添加
            this.$_invoke('trainManage_saveMaterial', {
                material_id: this.material_id,
                id: this.$props.id,
                ...this.form_data}).then(() => {
              this.$_msg.success('添加消防器材成功');
              this.getData();
            }).finally(() => {
              this.submitting = false;
            })
          } else {//修改
            
          }
        }
      })

    },
    
    //删除
    del(id) {
      this.$confirm("确定删除该条记录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$_invoke(`trainManage_deleteMaterialStock`, { id }).then((ret) => {
            if (ret != true) {
                this.$_msg.success("删除失败");
            } else {
                this.$_msg.success("删除成功");
                this.getData();
            }
          });
        })
        .catch(() => { });
    },
    
    //编辑/保存，改变状态
    edit_obsoleted(row, mode) {
        console.log(row.show);
        if (mode == "edit") {
            row.show = true;
        } else {
            row.show = false;
        }

        //save
        if (mode == "save") {
            this.submitting = true;
            if (this.hasId) {
                this.$_invoke('trainManage_updateMaterial', {id: row.id, 
                                                                material_quantity: row.material_quantity, 
                                                                producted_at: row.producted_at})
                    .then(() => {
                this.$_msg.success('修改消防器材成功');
                this.getData();
              }).finally(() => {
                this.submitting = false;
              })
            }
        }
    }
    
  },
}
</script>